import { Checkbox } from 'primereact/checkbox';
import { useContext } from "react";
import { ParameterContext } from "../contexts/ParameterContext";

export const CheckboxAdvantage = ({ advatage, formData, handleChange, index, wish, advIndex }) => {
    const { parameters } = useContext(ParameterContext);

    return (
        wish
            ? <>
                <div className="d-flex rounded flex-wrap w-100 gap-1 adv-checkbox px-3 justify-content-between px-4 py-2 px-2-mob py-3-mob">
                    <label className='w-90 w-100-mob'>{advatage.name}</label>
                    <div className="d-flex">
                        <Checkbox
                            inputId="lnccid"
                            name={advatage.code}
                            onChange={(e) => handleChange(e, index)}
                            checked={wish[advatage.code]}
                            disabled={parameters.municipality.obshtina_name == 'БОТЕВГРАД' && advatage?.code == 'K120' && wish.sedGroup?.code == 'K240'}
                        />
                        &nbsp;&nbsp;Да
                    </div>
                </div>
            </>
            : <div className="d-flex rounded flex-wrap w-100 flex-col-mob gap-1 adv-checkbox px-3 justify-content-between px-4 px-2-mob py-3-mob">
                <label className="w-90 mb-2-mob">{advatage.name}</label>
                <div className="d-flex">
                    <Checkbox
                        inputId="lnccid"
                        name={advatage.code}
                        onChange={(e) => handleChange(e, index)}
                        checked={formData.commonAdvantages && formData.commonAdvantages[advatage.code]}
                    />
                    &nbsp;&nbsp;Да
                </div>
            </div>

    )
}